import { render, staticRenderFns } from "./QuoteElement.vue?vue&type=template&id=05e4acbe&scoped=true&"
import script from "./QuoteElement.vue?vue&type=script&lang=js&"
export * from "./QuoteElement.vue?vue&type=script&lang=js&"
import style0 from "./QuoteElement.vue?vue&type=style&index=0&id=05e4acbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e4acbe",
  null
  
)

export default component.exports